<!-- TODO: isolate program > composables/smaller files before moving to composition API -->

<template>
  <h3>VIZBI <span>Public Talks</span></h3>
  <TimeZone />
  <br />
  <div v-if="!showEvents()" id="signin">
    This page will provide access the Masterclass and VIZBI videos after they have streamed.
  </div>
  <div v-else class="clearBoth">
    <p class="intro">
      This page gives access to the Zoom Webinar links to access public talks freely streamed during
      the VIZBI event.
      <!-- <span v-if="showLinkAt < 1000"
        >Zoom links for each event will appear below {{ showLinkAt }} minutes before the start time.</span
      > -->
    </p>
    <p class="intro">
      We recommend you
      <a href="https://support.zoom.us/hc/en-us/articles/201362233">use this link</a> to determine
      if you have the <a href="https://zoom.us/download">latest Zoom desktop client</a>.
    </p>
    <!-- <p class="intro">
      If you need help, you can contact the VIZBI support team via
      <a href="https://app.purechat.com/w/byqeil">this chat link</a>
    </p> -->
    <LiveEvent
      v-for="eventName in ['VIZBI 2025']"
      :key="eventName"
      :event-name="eventName"
      :public="true" />
  </div>
</template>

<script setup>
const log = (msg) => process.env.VUE_APP_DEV && console.log(); // eslint-disable-line
import TimeZone from "@/components/TimeZone";
import LiveEvent from "@/components/LiveEvent";
import showEvents from "@/composables/useShowEvents";
</script>

<style scoped>
h3 {
  display: inline;
  float: left;
}
#timezone {
  float: right;
  margin-top: 12px; /* same as App.vue/h3 */
  margin-bottom: 8px; /* same as App.vue/h3 */
  font-size: 14px;
  line-height: 33px;
  clear: right; /* https://stackoverflow.com/q/3415635 */
}
.clearBoth {
  clear: both; /* needed to clear two floats above */
  margin-top: 5px;
}
p.intro {
  font-weight: 300;
  /* font-style: italic; */
}
div.description {
  text-align: left;
  text-decoration: none;
  font-size: 1.1rem;
  color: black;
}
h3 span {
  font-weight: 300;
}
</style>
